import * as React from "react";
const SvgFiRrSaxophone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-saxophone_svg__a)">
      <path
        fill="#062147"
        d="M23 0h-1.024a2.98 2.98 0 0 0-2.865 2.113l-.24.782-.17-.053c-.474-.147-.824-.255-1.071-.339a1 1 0 1 0-.647 1.893c.26.089.629.203 1.128.357l.19.059-.733 2.508-.314-.098c-.488-.151-.848-.262-1.101-.348a1 1 0 0 0-1.27.625 1 1 0 0 0 .627 1.268c.265.09.64.207 1.15.365l.347.107-.773 2.651c-.834 2.366-2.23 5.109-3.76 5.109-1.317 0-1.471-1.049-1.475-1.5v-3.488c.012-.461.189-1.012.976-1.012a1 1 0 1 0 0-2h-11a1.001 1.001 0 0 0 0 2.001q.529 0 .762.235c.22.223.266.609.264.765v4.332c0 2.976 1.223 5.406 3.354 6.666 1.078.636 2.364.983 3.646 1.003 3.188 0 6.146-1.937 7.102-4.745.383-1.124 1.158-3.74 2.012-6.662.407-1.161 2.443-8.388 2.907-9.89a.995.995 0 0 1 .955-.703H23a1 1 0 1 0 0-2zm-8.791 18.61c-.683 2.007-2.865 3.39-5.21 3.39a5.35 5.35 0 0 1-2.627-.725C4.864 20.384 4 18.583 4 16.332v-4.293c.002-.077.01-.514-.153-1.039h5.318A3.3 3.3 0 0 0 9 12v3.49c-.002.156.014 1.557 1.012 2.565.427.431 1.2.944 2.464.944.643 0 1.233-.187 1.773-.507zM8.999 24c-.04 0 .042 0 0 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-saxophone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSaxophone;
